<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <form [formGroup]="editRegistroForm" id="formulario" class="tipo-abonado-form">
      <!-- Sección: Datos básicos -->
      <section class="section-card">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.DatosBasicos || "Datos básicos" }}</h3>
          <p class="section-subtitle">{{ translation?.DatosBasicosHintSinCodigo || translation?.DatosBasicosHint || "Nombre y descripción del tipo de abonado. El código lo asigna el sistema." }}</p>
        </div>
        <div class="section-grid section-grid--datos-basicos">
          <div class="datos-basicos-row">
            <div
              class="codigo-etiqueta"
              role="group"
              [attr.aria-label]="(translation?.Codigo || 'Código') + ', ' + textoEtiquetaCodigo"
            >
              <span class="codigo-etiqueta__label">{{ translation?.Codigo || 'Código' }}</span>
              <span class="codigo-etiqueta__valor">{{ textoEtiquetaCodigo }}</span>
              <input type="hidden" formControlName="Codigo" />
            </div>
            <mat-form-field appearance="outline" class="field-nombre">
              <mat-label>{{ translation?.Nombre || 'Nombre' }}</mat-label>
              <input matInput formControlName="Nombre" maxlength="30" (input)="onInputCaracteresProhibidos($event, 'Nombre')" />
              <mat-hint align="end">{{ (editRegistroForm.get('Nombre')?.value?.length || 0) }}/30</mat-hint>
              <mat-error *ngIf="validateFields('Nombre')">{{ getErrorMessage("Nombre") }}</mat-error>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="field-descripcion">
            <mat-label>{{ translation?.Descripcion || 'Descripción' }}</mat-label>
            <textarea
              matInput
              formControlName="Descripcion"
              maxlength="255"
              rows="1"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              (input)="onInputCaracteresProhibidos($event, 'Descripcion')"
            ></textarea>
            <mat-hint align="end">{{ (editRegistroForm.get('Descripcion')?.value?.length || 0) }}/255</mat-hint>
            <mat-error *ngIf="validateFields('Descripcion')">{{ getErrorMessage("Descripcion") }}</mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- Sección: Textos de visualización -->
      <section class="section-card">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.TextosVisualizacion || "Textos de visualización" }}</h3>
          <p class="section-subtitle">{{ translation?.TextosVisualizacionHint || "Textos mostrados en pantalla, impresión y display." }}</p>
        </div>
        <div class="section-grid section-grid--3col">
          <mat-form-field appearance="outline" class="field-texto">
            <mat-label>{{ translation?.TextoEnPantalla || 'Texto en pantalla' }}</mat-label>
            <input matInput formControlName="TextoPantalla" maxlength="30" (input)="onInputCaracteresProhibidos($event, 'TextoPantalla')" />
            <mat-hint align="end">{{ (editRegistroForm.get('TextoPantalla')?.value?.length || 0) }}/30</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="field-texto">
            <mat-label>{{ translation?.TextoImpresion || 'Texto impresión' }}</mat-label>
            <input matInput formControlName="TextoImpresion" maxlength="30" (input)="onInputCaracteresProhibidos($event, 'TextoImpresion')" />
            <mat-hint align="end">{{ (editRegistroForm.get('TextoImpresion')?.value?.length || 0) }}/30</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="field-texto">
            <mat-label>{{ translation?.TextoEnDisplay || 'Texto en display' }}</mat-label>
            <input matInput formControlName="TextoDisplay" maxlength="30" (input)="onInputCaracteresProhibidos($event, 'TextoDisplay')" />
            <mat-hint align="end">{{ (editRegistroForm.get('TextoDisplay')?.value?.length || 0) }}/30</mat-hint>
          </mat-form-field>
        </div>
      </section>

      <!-- Sección: Clasificación -->
      <section class="section-card">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.Clasificacion || "Clasificación" }}</h3>
          <p class="section-subtitle">{{ translation?.ClasificacionHint || "Grupo, categoría, tipo de producto y canales." }}</p>
        </div>
        <div class="section-grid section-grid--3col">
          <app-input-filter
            *ngIf="gruposTipoAbonado?.length"
            formControlText="idGrupo"
            [label]="translation?.GrupoTipoAbonado || 'Grupo tipo abonado'"
            [placeHolderTranslation]="translation?.GrupoTipoAbonado || 'Grupo tipo abonado'"
            [list]="gruposTipoAbonado"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('idGrupo')?.value"
            [required]="true"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            *ngIf="categorias?.length"
            formControlText="CategoriaId"
            [label]="translation?.Categoria || 'Categoría'"
            [placeHolderTranslation]="translation?.Categoria || 'Categoría'"
            [list]="categorias"
            textShow="chNombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('CategoriaId')?.value"
            [required]="true"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            *ngIf="tiposProductos?.length"
            formControlText="TipoProductoId"
            [label]="translation?.TipoProducto || 'Tipo producto'"
            [placeHolderTranslation]="translation?.TipoProducto || 'Tipo producto'"
            [list]="tiposProductos"
            textShow="Descripcion"
            dataInput="pkId"
            [data]="editRegistroForm.get('TipoProductoId')?.value"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <!-- Canales: obligatorio si ObligatorioCanalesEntradas=1 -->
          <app-input-filter
            *ngIf="(asociarCentrosCosteCanales || obligatorioCanalesEntradas) && canales?.length"
            formControlText="CanalId"
            [label]="translation?.Canales || 'Canales'"
            [placeHolderTranslation]="translation?.CanalesPlaceholder || translation?.Canales || 'Canales'"
            [list]="canales"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('CanalId')?.value"
            [required]="obligatorioCanalesEntradas"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
        </div>
      </section>

      <!-- Sección: Configuración adicional -->
      <section class="section-card">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.ConfiguracionAdicional || "Configuración adicional" }}</h3>
          <p class="section-subtitle">{{ translation?.ConfiguracionAdicionalHint || "Tipo control, datos nominativos, grupo edad y posición en botonera." }}</p>
        </div>
        <div class="section-grid section-grid--auto-fill">
          <app-input-filter
            *ngIf="tiposControl?.length"
            formControlText="CodigoTipoControl"
            [label]="translation?.TipoControl || 'Tipo control'"
            [placeHolderTranslation]="translation?.TipoControl || 'Tipo control'"
            [list]="tiposControl"
            textShow="Nombre"
            dataInput="CodigoTipoControl"
            [data]="editRegistroForm.get('CodigoTipoControl')?.value"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            formControlText="TEDatosId"
            [label]="translation?.DatosNominativos || 'Datos nominativos'"
            [placeHolderTranslation]="translation?.DatosNominativos || 'Datos nominativos'"
            [list]="tiposEntradaDatos"
            [disabled]="!tiposEntradaDatos?.length"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('TEDatosId')?.value"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            *ngIf="gruposEdad?.length"
            formControlText="GrupoEdadId"
            [label]="translation?.GrupoEdad || 'Grupo edad'"
            [placeHolderTranslation]="translation?.GrupoEdad || 'Grupo edad'"
            [list]="gruposEdad"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('GrupoEdadId')?.value"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            *ngIf="grupoReportAbonado"
            formControlText="GrupoReportId"
            [label]="translation?.GrupoReportAbonado || 'Grupo report abonado'"
            [placeHolderTranslation]="translation?.GrupoReportAbonado || 'Grupo report abonado'"
            [list]="gruposReport"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('GrupoReportId')?.value"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.TipoOperacion || 'Tipo de operación' }}</mat-label>
            <mat-select formControlName="idTipoOperacion">
              <mat-option [value]="null">--</mat-option>
              <mat-option [value]="1">{{ translation?.Nuevo || 'Nuevo' }}</mat-option>
              <mat-option [value]="2">{{ translation?.Renovacion || 'Renovación' }}</mat-option>
              <mat-option [value]="3">{{ translation?.Ampliacion || 'Ampliación' }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="posicion-botonera-field">
            <mat-label>{{ translation?.PosicionEnBotonera || 'Posición en botonera' }}</mat-label>
            <mat-select formControlName="TeclaRapida">
              <mat-option [value]="null">--</mat-option>
              <mat-option *ngFor="let opt of botoneraOpciones" [value]="opt.TeclaRapida">
                {{ opt.TeclaRapida }} : {{ opt.NombreTipo || "" }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <!-- Sección: Opciones de venta -->
      <section class="section-card">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.OpcionesVenta || "Opciones de venta" }}</h3>
          <p class="section-subtitle">{{ translation?.OpcionesVentaHint || "Configuración de venta, ticket e impresión." }}</p>
        </div>
        <div class="toggles">
          <div
            class="toggle-item toggle-item--stack"
            [class.toggle-item--error]="validateOpcionVentaToggle('ALaVenta')"
          >
            <div class="toggle-item__row">
              <span class="toggle-label"
                >{{ translation?.ALaVenta || "A la venta" }}
                <span class="toggle-required" aria-hidden="true">*</span></span
              >
              <mat-slide-toggle formControlName="ALaVenta"></mat-slide-toggle>
            </div>
            <span
              class="toggle-item__error"
              *ngIf="validateOpcionVentaToggle('ALaVenta')"
              >* {{ textoCampoRequerido }}</span
            >
          </div>
          <div
            class="toggle-item toggle-item--stack"
            [class.toggle-item--error]="validateOpcionVentaToggle('TicketVendido')"
          >
            <div class="toggle-item__row">
              <span class="toggle-label"
                >{{ translation?.TicketVendido || "Ticket vendido" }}
                <span class="toggle-required" aria-hidden="true">*</span></span
              >
              <mat-slide-toggle formControlName="TicketVendido"></mat-slide-toggle>
            </div>
            <span
              class="toggle-item__error"
              *ngIf="validateOpcionVentaToggle('TicketVendido')"
              >* {{ textoCampoRequerido }}</span
            >
          </div>
          <div
            class="toggle-item toggle-item--stack"
            [class.toggle-item--error]="
              validateOpcionVentaToggle('ImprimirTicket')
            "
          >
            <div class="toggle-item__row">
              <span class="toggle-label"
                >{{ translation?.ImprimirTicket || "Imprimir ticket" }}
                <span class="toggle-required" aria-hidden="true">*</span></span
              >
              <mat-slide-toggle
                formControlName="ImprimirTicket"
              ></mat-slide-toggle>
            </div>
            <span
              class="toggle-item__error"
              *ngIf="validateOpcionVentaToggle('ImprimirTicket')"
              >* {{ textoCampoRequerido }}</span
            >
          </div>
          <div class="toggle-item">
            <span class="toggle-label">{{
              translation?.ImpresionConjunta || "Impresión conjunta"
            }}</span>
            <mat-slide-toggle formControlName="ImpresionConjunta"></mat-slide-toggle>
          </div>
        </div>
      </section>

      <!-- Sección: Taxonomía (US: solo si AppConfig Taxonomia = 1) -->
      <section class="section-card" *ngIf="taxonomiaActiva">
        <div class="section-header">
          <h3 class="section-title">{{ translation?.Taxonomia || 'Taxonomía' }}</h3>
          <p class="section-subtitle">{{ translation?.TaxonomiaHint || "Configuración de centro de coste, tipo de precio y niveles." }}</p>
        </div>
        <div class="taxonomia-stack">
        <!-- Fila 1: 3 selects TX (sem coluna vazia) -->
        <div class="section-grid section-grid--taxonomia-top">
          <app-input-filter
            formControlText="TXCentroCosteId"
            [label]="labelTxCentroCoste"
            [placeHolderTranslation]="labelTxCentroCoste"
            [list]="txCentroCoste || []"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('TXCentroCosteId')?.value"
            [required]="true"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            formControlText="iTXTipoPrecioId"
            [label]="labelTxTipoPrecio"
            [placeHolderTranslation]="labelTxTipoPrecio"
            [list]="txTipoPrecio || []"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('iTXTipoPrecioId')?.value"
            [required]="true"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <app-input-filter
            formControlText="iTXCanalVentasId"
            [label]="labelTxCanalVentas"
            [placeHolderTranslation]="labelTxCanalVentas"
            [list]="txCanalVentas || []"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editRegistroForm.get('iTXCanalVentasId')?.value"
            [required]="true"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromChild($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
        </div>
        <!-- Niveles 1–7: grid que preenche naturalmente -->
        <div class="section-grid section-grid--taxonomia-niveles">
          <ng-container *ngFor="let n of [1,2,3,4,5,6,7]">
            <mat-form-field
              appearance="outline"
              *ngIf="txNiveles[n]?.length || n === 1"
              class="taxonomia-nivel-field"
            >
              <mat-label>{{ (translation?.Nivel || 'Nivel') }} {{ n }} TX</mat-label>
              <mat-select
                [formControlName]="'Nivel' + n"
                (selectionChange)="onNivelTaxonomiaChange(n, $event.value)"
              >
                <mat-option [value]="null">--</mat-option>
                <mat-option *ngFor="let item of txNiveles[n]" [value]="item">
                  {{ displayTaxonomiaNivelNombre(item) }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validateFields('Nivel' + n)">{{ getErrorMessage('Nivel' + n) }}</mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <!-- Información: Revenue category y Cuenta visitante (solo si nivel final seleccionado y TieneSucesor=0) -->
        <div class="taxonomia-info" *ngIf="mostrarTaxonomiaInfo">
          <div class="taxonomia-info-item" *ngIf="taxonomiaRevenueCategory">
            <span class="taxonomia-info-label">{{ translation?.RevenueCategory || 'Revenue category' }}:</span>
            <span class="taxonomia-info-value">{{ taxonomiaRevenueCategory }}</span>
          </div>
          <div class="taxonomia-info-item" *ngIf="mostrarCuentaVisitante">
            <span class="taxonomia-info-label">{{ translation?.CuentaVisitante || 'Cuenta visitante' }}:</span>
            <span class="taxonomia-info-value">{{ taxonomiaCuentaVisitante }}</span>
          </div>
        </div>
        </div>
      </section>

      <!-- Sección: Centros -->
      <section class="section-card" *ngIf="asociarCentros">
        <div class="section-header section-header--dual-list">
          <h3 class="section-title">{{ translation?.Centros || 'Centros' }}</h3>
          <p class="section-subtitle">{{ translation?.CentrosHintTipoAbonado || centrosSectionHintFallback }}</p>
        </div>
      <customan-dual-list
        [source]="centrosSinAsignar"
        [(destination)]="centrosAsignados"
        key="pkId"
        display="Nombre"
        [format]="format"
        [height]="dualListHeight"
      >
      </customan-dual-list>
      </section>

      <!-- Sección: Entradas (producto + control de acceso) -->
      <section class="section-card">
        <div class="section-header section-header--entradas">
          <div class="section-header--entradas-text">
            <h3 class="section-title">{{ translation?.SeccionEntradasTipoAbonado || 'Entradas' }}</h3>
            <p class="section-subtitle">{{
              translation?.SeccionEntradasTipoAbonadoHint
                || translation?.ProductoHintTipoAbonado
                || 'Añada tipos de entrada y el control de acceso.'
            }}</p>
          </div>
          <button
            type="button"
            mat-mini-fab
            color="primary"
            class="btn-add-entrada"
            (click)="addEntradaRow()"
            [attr.aria-label]="translation?.Anadir || 'Añadir'"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="entradas-table" role="table">
          <div class="entradas-table-head" role="row">
            <span class="entradas-col-acciones" role="columnheader">{{ translation?.Acciones || 'Acciones' }}</span>
            <span class="entradas-col-producto" role="columnheader">{{ translation?.Producto || 'Producto' }}</span>
            <span class="entradas-col-acceso" role="columnheader">{{ translation?.AccesoControlTipoAbonado || 'Acceso' }}</span>
          </div>
          <div
            class="entradas-table-row"
            role="row"
            *ngFor="let row of entradasRows; trackBy: trackEntradaRow; let i = index"
          >
            <div class="entradas-col-acciones" role="cell">
              <button
                type="button"
                mat-icon-button
                (click)="removeEntradaRow(i)"
                [attr.aria-label]="translation?.Borrar || 'Eliminar'"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="entradas-col-producto" role="cell">
              <mat-form-field appearance="outline" class="entradas-select-field">
                <mat-label>{{ translation?.Producto || 'Producto' }}</mat-label>
                <mat-select
                  [value]="row.tipoEntradaId"
                  (selectionChange)="row.tipoEntradaId = $event.value; panelService.setDiscardChanges(false)"
                >
                  <mat-option [value]="null">--</mat-option>
                  <mat-option *ngFor="let p of productosDisponibles" [value]="p.pkId">{{ p.Nombre }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="entradas-col-acceso" role="cell">
              <mat-slide-toggle
                [checked]="row.controlAcceso"
                (change)="row.controlAcceso = $event.checked; panelService.setDiscardChanges(false)"
              >
                {{ row.controlAcceso ? (translation?.Si || 'Sí') : (translation?.No || 'No') }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <p *ngIf="submitAttempted && !entradasRows?.length" class="producto-error">
          {{ translation?.TipoAbonadoEntradasMinimoUna || translation?.HintTipoAbonadoProducto || 'Debe añadir al menos una entrada.' }}
        </p>
      </section>

      <!--
        LEGACY: dual-list producto (reemplazado por sección Entradas; conservado por referencia).
      <section class="section-card">
        <div class="section-header section-header--dual-list">
          <h3 class="section-title">{{ translation?.Producto || 'Producto' }}</h3>
          <p class="section-subtitle">{{
            translation?.ProductoHintTipoAbonado
              || translation?.HintTipoAbonadoProducto
              || 'Seleccione al menos un tipo de entrada (producto) asociado a este tipo de abonado.'
          }}</p>
        </div>
        <customan-dual-list
          [source]="productosSinAsignar"
          [(destination)]="productosAsignados"
          key="pkId"
          display="Nombre"
          [format]="format"
          [height]="dualListHeight"
        >
        </customan-dual-list>
        <p *ngIf="submitAttempted && !productosAsignados?.length" class="producto-error">
          {{ translation?.HintTipoAbonadoProducto || translation?.CampoObligatorio || 'Debe seleccionar al menos un producto.' }}
        </p>
      </section>
      -->
    </form>
  </div>
</div>
